import axios from "axios";
import { store } from "store/store";
import { setLoading } from "store/loadingReducer";
import { useEffect } from "react";
import { ModalButtons, ModalImages, useModal } from "context/modalContext";
import { logout } from "store/authReducer";

const baseURL = window.urlAPI;
const genApiAxios = axios.create({
  baseURL,
});

genApiAxios.interceptors.request.use((config) => {
  const { dispatch } = store;
  dispatch(setLoading(true));
  return config;
});

genApiAxios.interceptors.response.use((response) => {
  const { dispatch } = store;
  dispatch(setLoading(false));
  return response;
});

// axiosInstance.interceptors.request.use((config) => {
//   if (config.data) {
//     Object.keys(config.data).forEach(async (key) => {
//       // Find a valid date object and format it
//       if (config.data[key] instanceof Date && !Number.isNaN(config.data[key])) {
//         config.data[key] = moment(config.data[key]).format("YYYY-MM-DDTHH:mm");
//       }
//     });
//   }
//   const state = store.getState();
//   config.headers = {
//     ...config.headers,
//     Authorization: `Bearer ${state.auth.token}`,
//   };
//   return config;
// });

// axiosInstance.interceptors.response.use(
//   (response) => {
//     return response;
//   },
//   async (error) => {
//     console.log("error", error);
//     const originalRequest = error.config;
//     if (error?.message === "Network Error") {
//       const errorObject = {
//         response: {
//           message: error.message,
//           status: 503,
//         },
//       };
//       return Promise.reject(errorObject);
//     }
//     if (error?.response?.status === 453 && !originalRequest._retry) {
//       const { dispatch } = store;
//       dispatch({ type: LOGOUT });
//     }
//     if (error?.response?.status === 401 && !originalRequest._retry) {
//       const state = store.getState();
//       const { dispatch } = store;
//       originalRequest._retry = true;
//       try {
//         const refreshResponse = await refreshToken({
//           refreshToken: state.auth.refreshToken,
//         });
//         dispatch({ type: REFRESH_TOKEN, payload: refreshResponse });
//         return axiosInstance(originalRequest);
//       } catch (ex) {
//         return Promise.reject(error);
//       }
//     }
//     return Promise.reject(error);
//   }
// );
const GenApiAxiosInterceptor = ({ children }) => {
  const { dispatch } = store;
  const { openModal } = useModal();

  useEffect(() => {
    const resInterceptor = (response) => {
      if (response?.data?.status === "ERROR") {
        openModal({
          title: "Business Key ERP",
          message: response?.data?.data,
          imageType: ModalImages.Error,
          buttons: ModalButtons.OK,
          callback: () => {
            dispatch(setLoading(false));
          },
        });
      } else if (response?.data?.status === "SystemError") {
        openModal({
          title: "Business Key ERP",
          message: response?.data?.data,
          imageType: ModalImages.Error,
          buttons: ModalButtons.OK,
          callback: () => {
            dispatch(setLoading(false));
          },
        });
      }
      return response;
    };

    const errInterceptor = (error) => {
      if (error?.response?.status === 401)
        openModal({
          title: "Business Key ERP",
          message: error?.message,
          imageType: ModalImages.Error,
          buttons: ModalButtons.OK,
          callback: () => {
            dispatch(logout());
          },
        });
      if (error?.code === "ERR_NETWORK")
        openModal({
          title: "Business Key ERP",
          message: error?.message,
          imageType: ModalImages.Error,
          buttons: ModalButtons.OK,
          callback: () => {
            dispatch(setLoading(false));
          },
        });
      return Promise.reject(error);
    };

    const interceptor = genApiAxios.interceptors.response.use(
      resInterceptor,
      errInterceptor
    );

    return () => genApiAxios.interceptors.response.eject(interceptor);
  }, [openModal]);
  return children;
};

export { genApiAxios, GenApiAxiosInterceptor };
